<div class="transport-weighings">
  <div class="transport-weighings-layout">
    <div class="table-container">
      <sc-tmc-table [tableModel]="tableModel" [hideFilter]="true" #tmcTableComponent></sc-tmc-table>
    </div>
    <div class="print-button-bar">
      <button class="confirm-button print-button" mat-stroked-button (click)="createPrintout()"
      [matTooltip]="'create printout' | translate:['tmc.transport-details.dialog.weighings.action.createPrintout', translationService.language]">
      <mat-icon><sc-icon iconClass="fa-print"></sc-icon></mat-icon>
      {{'create printout' | translate:['tmc.transport-details.dialog.weighings.action.createPrintout',
      translationService.language]}}
    </button>
    <sc-content-spacer [grow]="true"></sc-content-spacer>
    </div>
  </div>
</div>
